// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1C1Y3","rightAdornment":"Header_rightAdornment__29Z6l"};